import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { DEFAULT_LOGIN_PAGE_DETAILS } from '../../assets/objects/default-login-object';
import { Router } from '@angular/router';

@Injectable()
export class ClientDetailsService {

    private clientdetails: any = null;
    private loginPagedetails: any;

    constructor(private http: HttpClient, private router: Router) { }

    protected standardHeaders() {
        return {
            'Accept': 'application/json',
            'token': '12345'
        };
    }

    public loadClientLoginDetails(param?): Promise<any> {
        const clientDetailsPromise = new Promise((resolve, reject) => {
            const url = environment.api_url + '/organisation/params';
            if (param) {
                const data = { 'code': param };
                this.http.post(url, data, { headers: this.standardHeaders() }).
                    pipe(
                        map(res => this.clientdetails = res)
                    )
                    .subscribe(response => {
                        this.clientdetails = response['data'];
                        if (response['status']['success'] !== 'Fail') {
                            return resolve(this.clientdetails);
                        } else {
                            this.router.navigate(['']);
                            return reject(null);
                        }
                    });
            } else { return reject(null); }
        });

        return clientDetailsPromise.then(
            (clientData) => {
                return clientData;
            }
        ).catch((defaultData) => {
            
            return DEFAULT_LOGIN_PAGE_DETAILS;
        });
    }

    public getClientDetails() {
        return this.loginPagedetails;
    }
}






// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/services/client-login-details.service.ts